import { render } from "./LayoutContainer.vue?vue&type=template&id=349754be"
import script from "./LayoutContainer.vue?vue&type=script&lang=js"
export * from "./LayoutContainer.vue?vue&type=script&lang=js"
script.render = render

export default script